/**
 * Helper to remove keys which stands for null values from object. Helpful for usage
 * with destructuring assignment.
 * Before: const { city: { id }={} } = overview; If overview is { city: null }, id won't be extracted, even worse it will raise error "Cannot read property 'id' of null".
 * After: const { city: { id }={} } = removeNullKeys(overview); id will be extracted as undefined
 * @param {object} object - Object to remove keys from.
 */
export default function removeNullKeys(object) {
  return Object.keys(object).reduce(
    (obj, key) => (object[key] === null ? obj : { ...obj, [key]: object[key] }),
    {},
  );
}
